import { createNavigation } from 'next-intl/navigation';
import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ['de', 'en', 'pt'],

  // Used when no locale matches
  defaultLocale: 'en',

  // The prefix for the default locale (e.g. /en/about)
  // We want to enforce prefixes for all locales to ensure consistent SEO
  localePrefix: 'always',

  // Disable alternate links in HTTP headers to avoid duplicate hreflang
  // We already provide hreflang via HTML <link> tags in generateMetadata
  alternateLinks: false,
});

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing);
